import React from 'react';
import { useTranslation } from 'react-i18next';

export type ImageSize = 'square' | '9:16' | '4:5';

interface ImageSizeSelectProps {
  value: ImageSize;
  onChange: (value: ImageSize) => void;
}

export const ImageSizeSelect: React.FC<ImageSizeSelectProps> = ({ value, onChange }) => {
  const { t } = useTranslation();
  
  const options = [
    { 
      value: 'square' as ImageSize, 
      label: t('contentCreation.imageSize.square', 'Square (1:1)'), 
      emoji: '🔲', 
      description: t('contentCreation.imageSizeDescriptions.square', 'Perfect for most social platforms')
    },
    { 
      value: '9:16' as ImageSize, 
      label: t('contentCreation.imageSize.portrait916', 'Portrait (9:16)'), 
      emoji: '📱', 
      description: t('contentCreation.imageSizeDescriptions.portrait916', 'Ideal for Stories and TikTok')
    },
    { 
      value: '4:5' as ImageSize, 
      label: t('contentCreation.imageSize.portrait45', 'Portrait (4:5)'), 
      emoji: '🖼️', 
      description: t('contentCreation.imageSizeDescriptions.portrait45', 'Good for Instagram and Pinterest')
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          onClick={() => onChange(option.value)}
          className={`flex items-center gap-3 p-3 rounded-lg border ${
            value === option.value
              ? 'border-primary-600 bg-primary-50 text-primary-700'
              : 'border-gray-300 hover:border-primary-600'
          }`}
        >
          <div className="w-8 h-8 flex items-center justify-center bg-gray-100 rounded-full">
            <span className="text-xl">{option.emoji}</span>
          </div>
          <div className="text-left">
            <div className="font-medium text-sm">{option.label}</div>
            <div className="text-xs text-gray-500">{option.description}</div>
          </div>
        </button>
      ))}
    </div>
  );
};

export default ImageSizeSelect; 